import React from 'react';
import styled from '@emotion/styled';
import { useTexts } from '@devsisters/gatsby-plugin-i18n';

import { scaledCss } from '~/src/css';
import { Section } from '~/src/components/bravecookies/section';

interface GreetingProps {
  nickname?: string;
}
const Greeting: React.FC<GreetingProps> = ({ nickname }) => {
  const t = useTexts();
  return (
    <GreetingSection>
      {nickname && <Nickname>{nickname}</Nickname>}
      {t`$description1`}
    </GreetingSection>
  );
};

export default Greeting;

const GreetingSection = styled(Section)(
  scaledCss({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    marginX: [25, '25px'],
    marginBottom: [50, '50px'],
    paddingTop: [25, '25px'],
    paddingBottom: [30, '30px'],
    fontSize: [30, '30px'],
  })
);

const Nickname = styled('span')(
  scaledCss({
    display: 'block',
    marginBottom: '0.3em',
    letterSpacing: 0,
    fontSize: [40, '40px'],
    fontFamily: "'CookieRun', sans-serif",
    color: '#f52e66',
  })
);
